import CustomLoader, { LoaderColor, LoaderSize } from '../loader/CustomLoader';
import { useTheme } from 'styled-components';

const PrimaryButton = ({
  onClick,
  label,
  icon,
  disabled,
  isLoading,
  className,
  disabledWithoutColorChange,
  style,
  children,
  ...rest
}) => {
  const theme = useTheme();
  return (
    <button
      type="button"
      className={`primary-button relative ${disabled || isLoading ? 'disabled' : ''} ${className} ${disabledWithoutColorChange ? 'pointer-events-none' : ''}`}
      disabled={disabled || isLoading}
      onClick={onClick}
      style={style}
      {...rest}
    >
      {children ? children :
      <>
        {isLoading ? (
          <CustomLoader
            loaderSize={LoaderSize.SMALL}
            loaderColor={LoaderColor.GREY}
          />
        ) : (
          <>
            {label && <>{label}</>}
            {icon && <img className="icon-button" src={icon} alt="" />}
          </>
        )}
        {theme?.buttonDecorations?.primaryButtonDecoration && (
          <img
            src={theme.buttonDecorations.primaryButtonDecoration?.image}
            alt="toileGRoupe"
            className="absolute translate-y-[20px]"
          />
        )}
      </>
      }
    </button>
  );
};

export default PrimaryButton;
